import { __rest } from 'tslib';
import React, { useEffect } from 'react';
import { PeekBox, PeekStack, PeekTextField, PeekButton } from '@piiqtechnologies/ui-components';
import { usePannellumViewer } from '../../../../components/pannellum-viewer/PannellumProvider.js';
import { getNodeById } from '../../../../components/pannellum-viewer/pannellumUtils.js';
import '../../../../../types/AccessDevice.js';
import '../../../../../types/Analytics.js';
import '../../../../../types/CASACommunity.js';
import '../../../../../types/Community.js';
import '../../../../../types/DxSettings.js';
import '../../../../../types/MagicButton.js';
import '../../../../../types/Pannellum.js';
import '../../../../../types/Prospect.js';
import '../../../../../types/ProspectIntelligence.js';
import { NodeLinkType } from '../../../../../types/Space.js';
import '../../../../../types/Tour.js';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import { useError } from '../../../../../utils/ErrorProvider.js';
import { useLoader } from '../../../../../utils/LoaderProvider.js';
import { useRefetch } from '../../../../../utils/RefetchProvider.js';
import '../../../../../utils/NotificationProvider.js';
import { getUniqueTimeStampId } from '../../../../../utils/getUniqueId.js';
import '../../../../../utils/ContactProvider.js';
import '../../../../../utils/PolicyProvider.js';
import '../../../../../utils/AnalyticsProvider.js';
import '@analytics/storage-utils';
import '../../../../../utils/analyticsPlugin.js';
import '../../../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../../../utils/cookieUtils.js';
import '../../../../../utils/termsConditionsAgreementsUtils.js';
import { CreateHotspotModal } from './CreateHotspotModal.js';
import { HotspotEditingTooltip } from './HotspotEditingTooltip.js';
import { useLoadScene } from '../../../../components/pannellum-viewer/useNavigateScene.js';
import { HotspotHighlightIcon } from '../../../../components/pannellum-viewer/hotspot/HotspotIcon.js';
import '../../../../../services/base/baseDiscoverService.js';
import '../../../../../services/base/baseV3Service.js';
import '../../../../../services/base/baseInsightsService.js';
import '../../../../../services/sgtService.js';
import '../../../../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../../../../services/base/internalApiBaseService.js';
import '../../../../../services/base/casaBaseService.js';
import '../../../../../services/scanRequestsService.js';
import '../../../../../services/db/insightsReportsDB.js';
import '../../../../../services/aiDiscoverability.js';
import 'dot-object';
import '../../../../../apis/analytics/useDownloadAnalyticsReports.js';
import { useUpdateSpaceNode } from '../../../../../apis/space/useUpdateSpaceNode.js';
import '../../../../../apis/upload/useSignedURL.js';
import produce from 'immer';

const CreateHotspotTool = ({ type, modal: showModal, linkBackSceneId, linkBackStep, toggleCreateHotspotTool, }) => {
    const { getConfig, details, token, setViewerContext } = usePannellumViewer();
    const [updateSpaceNode, updatedSpace, updateSpaceNodeInProgress, updateSpaceNodeError] = useUpdateSpaceNode();
    const { nodeId } = getConfig();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const { loadScene } = useLoadScene();
    const node = getNodeById(details.nodes, nodeId);
    const toggleCreateHotspotModal = () => {
        toggleCreateHotspotTool();
    };
    const createNodeLink = (nodeLink, linkBackSceneId) => {
        const updatedNodeId = linkBackSceneId || nodeId;
        const updatedNode = details.nodes.find((item) => item._id === updatedNodeId);
        if (updatedNode) {
            const updatedSpaceNode = produce(updatedNode, (draftState) => {
                draftState.nodeLinks.push(nodeLink);
            });
            updateSpaceNode({
                spaceId: details._id,
                nodeId: updatedNodeId,
                node: {
                    nodeLinks: updatedSpaceNode.nodeLinks.map((_a) => {
                        var nodeLinkData = __rest(_a, ["_id"]);
                        return nodeLinkData;
                    }),
                },
            });
        }
    };
    const onCreateLinkBackHotspot = () => {
        const { name, nodeId } = getConfig();
        const nodeLink = {
            _id: getUniqueTimeStampId("hotspot"),
            label: name,
            type: NodeLinkType.Node,
            rotation: {
                pitch: 0,
                yaw: 0,
            },
            node: nodeId,
        };
        createNodeLink(nodeLink, linkBackSceneId);
        toggleCreateHotspotTool(type, showModal, linkBackSceneId, true);
    };
    const onCreateNodeLink = (nodeLink, linkBackNodeId) => {
        createNodeLink(nodeLink);
        toggleCreateHotspotTool(type, showModal, linkBackNodeId);
    };
    const onCreateInfospot = (infospot) => {
        const updatedSpaceNode = produce(node, (draftState) => {
            draftState.infospots.push(infospot);
        });
        updateSpaceNode({
            spaceId: details._id,
            nodeId,
            node: {
                infospots: updatedSpaceNode.infospots.map((_a) => {
                    var infospotData = __rest(_a, ["_id"]);
                    return infospotData;
                }),
            },
        });
        toggleCreateHotspotTool(type, showModal);
    };
    const onDone = () => {
        if (linkBackSceneId && linkBackStep) {
            const linkBackNode = getNodeById(details.nodes, linkBackSceneId);
            loadScene({ node: linkBackNode, details, token: token });
        }
        toggleCreateHotspotTool();
    };
    useEffect(() => {
        if (updatedSpace) {
            const { nodeId } = getConfig();
            if (linkBackStep) {
                setViewerContext({ details: updatedSpace });
                const linkBackNode = getNodeById(updatedSpace.nodes, linkBackSceneId);
                loadScene({ node: linkBackNode, details: updatedSpace, token: token });
                toggleCreateHotspotTool(type, false, nodeId, linkBackStep);
                return;
            }
            setRefetch({ sceneId: nodeId });
            setViewerContext({ details: updatedSpace });
            toggleCreateHotspotTool(type, false, linkBackSceneId);
        }
    }, [updatedSpace]);
    useEffect(() => {
        if (updateSpaceNodeError) {
            linkBackStep && toggleCreateHotspotTool(type, showModal, linkBackSceneId, false);
            setError(updateSpaceNodeError === null || updateSpaceNodeError === void 0 ? void 0 : updateSpaceNodeError.message);
        }
    }, [updateSpaceNodeError]);
    useEffect(() => {
        setLoader(updateSpaceNodeInProgress, "updateSpaceNode");
        return () => setLoader(false, "updateSpaceNode");
    }, [updateSpaceNodeInProgress]);
    const linkBackNodeName = linkBackSceneId && linkBackStep && getNodeById(details.nodes, linkBackSceneId).label;
    const editTooltipTitle = (!linkBackStep && "How to edit:") || `Place a link back to the ${linkBackNodeName}`;
    return (React.createElement(PeekBox, { sx: { position: "absolute", top: "0", left: "0" }, width: "100%" },
        React.createElement(PeekStack, { sx: { p: 1.5 }, direction: "row", justifyContent: "space-between", spacing: 1 },
            React.createElement(PeekBox, null,
                React.createElement(PeekTextField, { variant: "standard", sx: { m: 0, "& .MuiInput-root": { mt: 0, boxShadow: "none" } }, value: node.label, InputLabelProps: { required: true }, InputProps: {
                        readOnly: true,
                        disableUnderline: true,
                        "aria-label": "Image Name",
                    } })),
            !showModal && (React.createElement(PeekStack, { direction: "row", spacing: 1 },
                React.createElement(PeekBox, null, (linkBackSceneId && !linkBackStep && (React.createElement(PeekButton, { color: "secondary", onClick: onCreateLinkBackHotspot, variant: "contained", "aria-label": "Link Back Hotspot" }, "Next"))) || (React.createElement(PeekButton, { color: "secondary", onClick: onDone, variant: "contained", "aria-label": "Done Create Hotspot" }, "Done")))))),
        React.createElement(CreateHotspotModal, { onCreateNodeLink: onCreateNodeLink, onCreateInfospot: onCreateInfospot, hotspotType: type, open: !!showModal, onCloseCreateHotSpotModal: toggleCreateHotspotModal }),
        !showModal && (React.createElement(HotspotEditingTooltip, { description: React.createElement(React.Fragment, null,
                "Drag ",
                React.createElement(HotspotHighlightIcon, { type: type }),
                " to Move the link's position"), title: editTooltipTitle }))));
};

export { CreateHotspotTool, CreateHotspotTool as default };
